"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.object.to-string.js");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("element-ui/lib/theme-chalk/src/base.css");

require("element-ui/lib/theme-chalk/src/button.css");

var _button2 = _interopRequireDefault(require("element-ui/lib/button"));

require("element-ui/lib/theme-chalk/src/input.css");

var _input2 = _interopRequireDefault(require("element-ui/lib/input"));

require("element-ui/lib/theme-chalk/src/form-item.css");

var _formItem2 = _interopRequireDefault(require("element-ui/lib/form-item"));

require("element-ui/lib/theme-chalk/src/form.css");

var _form2 = _interopRequireDefault(require("element-ui/lib/form"));

var _locale = _interopRequireDefault(require("sk-ui/lib/mixins/locale"));

var _components;

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('div', {
    "class": ['sk-pwsPrompt', {
      'is-layer': _vm.layer
    }],
    attrs: {}
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.temp
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "pws"
    }
  }, [_c('el-input', {
    ref: "input",
    attrs: {
      "type": "password",
      "placeholder": _vm.placeholderPws
    },
    model: {
      value: _vm.temp.pws,
      callback: function callback($v) {
        _vm.$set(_vm.temp, "pws", $v);
      },
      expression: "temp.pws"
    }
  })], 1)], 1), _vm._v(" "), _vm.layer ? _c('div', {
    staticClass: "el-dialog__footer dialog-footer__custom",
    attrs: {}
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.confirm))]), _vm._v(" "), _c('el-button', {
    attrs: {},
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(_vm._s(_vm.cancel))])], 1) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
var _default2 = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'SkPromptPws',
  components: (_components = {}, (0, _defineProperty2["default"])(_components, _form2["default"].name, _form2["default"]), (0, _defineProperty2["default"])(_components, _formItem2["default"].name, _formItem2["default"]), (0, _defineProperty2["default"])(_components, _input2["default"].name, _input2["default"]), (0, _defineProperty2["default"])(_components, _button2["default"].name, _button2["default"]), _components),
  data: function data() {
    return {
      loading: false,
      placeholderPws: this.t('sk.adminPws'),
      confirm: this.t('sk.confirm'),
      cancel: this.t('sk.cancel'),
      temp: {
        pws: null
      },
      rules: {
        pws: [{
          required: true,
          message: this.t('sk.form.common_term_null_valid'),
          trigger: 'blur'
        }, {
          min: this.length.min || 1,
          max: this.length.max || 32,
          message: this.t('sk.form.common_term_length_valid', {
            min: this.length.min || 1,
            max: this.length.max || 32
          }),
          trigger: 'blur'
        }]
      }
    };
  },
  mixins: [_locale["default"]],
  props: {
    execute: Function,
    cb: Function,
    cancelCb: Function,
    layer: {
      type: Boolean,
      "default": false
    },
    length: {
      type: Object,
      "default": function _default() {
        return {
          min: 1,
          max: 32
        };
      }
    }
  },
  methods: {
    handleCancel: function handleCancel() {
      this.cancelCb && this.cancelCb();
    },
    handleOk: function handleOk() {
      var _this = this;

      this.loading = true;
      return new window.Promise(function (resolve, reject) {
        _this.$refs['dataForm'].validate(function (valid) {
          if (valid) {
            if (_this.execute) {
              _this.execute(_this.temp.pws).then(function () {
                _this.loading = false;
                _this.cb && _this.cb();
                resolve();
              })["catch"](function (e) {
                reject();
                _this.loading = false;
                throw e;
              });
            } else {
              resolve();
            }
          } else {
            _this.loading = false;
            reject();
          }
        });
      });
    }
  }
};
exports["default"] = _default2;